import React from "react";
import EducationMicroblading from "../Components/education/EducationMicroblading";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";

function EducationMicrobladingPage() {
  return (
    <>
      <TopBar />
      <Spacer2 />
      <EducationMicroblading />
    </>
  );
}

export default EducationMicrobladingPage;
